export default "__VITE_ASSET__BQ_tNJci__"